import React from 'react';
import XIcon from '../../images/Header/X-icon.png'
import logo from "../../images/PixelGameLogo.png";
import { Link } from "react-scroll";

const HeaderMenu = ({openMenu, className}) => {
    return (
        <div className={`header-menu-content ${className}`}>
            <div className='header-menu-row'>
                <img className='header-logo' style={{visibility: 'hidden'}} src={logo} alt="Pixel Game"/>
                <button  onClick={() => openMenu()}> <img src={XIcon} alt=""/> </button>
            </div>

            <nav>

                <ul className='menu-nav-list'>
                    <li className="menu-nav-item">
                        <Link onClick={() => openMenu()} to="section1" smooth={true} duration={500}  href="#">Комплекти</Link>
                    </li>
                    <li className="menu-nav-item">
                        <Link onClick={() => openMenu()} to="section2" smooth={true} duration={500} href="#">Каталог ігор</Link>
                    </li>
                    <li className="menu-nav-item">
                        <Link onClick={() => openMenu()} to="section3" smooth={true} duration={500} href="#">Доставка</Link>
                    </li>
                    <li className="menu-nav-item">
                        <Link onClick={() => openMenu()} to="section4" smooth={true} duration={500} href="#">FAQ</Link>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default HeaderMenu;